import React, { useState } from 'react'
import { CountUp } from 'use-count-up'
import axios from 'axios'
import { ReactComponent as WalletIcon } from '../../images/ic-wallet-w-bill.svg'
import { If, Then, Else, When } from 'react-if'
import Modal from 'react-modal'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Deposit from './Deposit'

function CretaSection({ refreshPage, address, profitData, userInfo, creta, userMatic, setCretaBuyModalOpen }) {
    const [maticAddress, setMaticAddress] = useState('')

    const [showMaticAddressForm, setShowMaticAddressForm] = useState(false)
    const [showWithdrawForm, setShowWithdrawForm] = useState(false)
    const [showDepositForm, setShowDepositForm] = useState(false)
    const [showTransferForm, setShowTransferForm] = useState(false)
    const [withdrawCretaAmount, setWithdrawCretaAmount] = useState('')

    const tronweb = window.tronWeb
    const userDeposit = profitData.deposit

    const [recipientName, setRecipientName] = useState('')
    const [transferAmount, setTransferAmount] = useState('')

    const onChangeRecipientName = (e) => {
        setRecipientName(e.target.value)
    }

    const onChangeTransferAmount = (e) => {
        setTransferAmount(e.target.value)
    }

    const onChangeFixMaticAddress = (e) => {
        setMaticAddress(e.target.value)
    }

    const onChangeWithdrawCreta = (e) => {
        setWithdrawCretaAmount(e.target.value)
    }

    const CountUpValue = (amount) => {
        if (amount === undefined || amount === 0 || amount === null) {
            return <CountUp end={0} thousandsSeparator="," />
        } else {
            return <CountUp isCounting start={0} end={amount} thousandsSeparator="," />
        }
    }

    async function cretaWithdrawRequest() {
        if (withdrawCretaAmount === '') {
            alert('Please enter the amount.')
            return
        }

        if (+withdrawCretaAmount !== Math.ceil(withdrawCretaAmount)) {
            alert('Please enter the quantity without decimal.')
            return
        }

        try {
            axios
                .post('api/cretaWithdrawRequest', {
                    address: address,
                    amount: +withdrawCretaAmount,
                })
                .then((res) => {
                    alert('The withdrawal request has been completed')
                    setWithdrawCretaAmount('')
                    setShowWithdrawForm(false)
                    refreshPage()
                })
                .catch((err) => {
                    if (err.response) {
                        console.log(err.response)
                        console.log(err.response.data.message)
                        alert(err.response.data.message)
                    }
                    setWithdrawCretaAmount('')
                    // refreshPage();
                })
        } catch (err) {
            alert(err)
            //TODO history.push('/');
        }
    }

    function maticFaucetRequest() {
        axios
            .post('api/maticFaucetRequest', {
                address: address,
            })
            .then((res) => {
                alert('The matic charging request has been completed.')
            })
            .catch((err) => {
                alert(err.response.data.message)
                if (err.response) {
                    console.log(err.response)
                }
            })
    }

    async function changeMaticAddress() {
        try {
            if (maticAddress === '') {
                alert('Please enter the address.')
                return
            }

            const regex = /^0x[a-fA-F0-9]{40}$/
            if (!regex.test(maticAddress)) {
                alert('The format of the CRETA Address is not match.')
                return false
            }

            if (maticAddress === '0x202655af326dE310491Cb54f120E02eE0da92b55') {
                alert('You have entered the smart contract address. Please enter your wallet address.')
                return false
            }

            const message = Math.random().toString(24).substring(3, 24)
            const signature = await tronweb.trx.sign(tronweb.toHex(message))

            axios
                .post('api/changeMaticAddress', {
                    address: address,
                    maticAddress: maticAddress,
                    signature: signature,
                    message: message,
                })
                .then((res) => {
                    alert(res.data)
                    refreshPage()
                })
                .catch((err) => {
                    if (err.response) {
                        alert(err.response.data.message)
                    }
                    //TODO history.push('/');
                })
        } catch (err) {
            if (err.response) {
                console.log(err.response)
                console.log(err.response.data.message)
                alert(err.response.data.message)
            }
        }
        setShowMaticAddressForm(false)
    }
    const notAllowedExchangeWallet = () => {
        return (
            <div className="dashboard-box-message red">
                <div className="message" style={{ marginTop: 0 }}>
                    한국의 거래소 고팍스의 CRETA주소를 출금주소로 절대 셋팅하지 마세요. 트레블룰로 입금처리가 안됩니다.<br></br>
                    Never set the withdrawal address to the CRETA address of the Korean exchange 'Gopax.' Deposits cannot be processed for 'Treble Rule'.
                </div>
            </div>
        )
    }
    async function transferCreta() {
        try {
            console.log(profitData)
            let name = recipientName ? recipientName.trim() : ''

            if (name === '') {
                alert("Please enter the recipient's ID.")
                return
            }
            if (userInfo.name.toLowerCase() === name.toLowerCase()) {
                alert('Unable to send to your own account.')
                return
            }

            if (transferAmount.trim() === '') {
                alert('Please enter the amount.')
                return
            }

            if (+transferAmount !== Math.ceil(transferAmount)) {
                alert('Please enter the quantity without decimal.')
                return
            }

            const message = Math.random().toString(24).substring(3, 24)
            const signature = await tronweb.trx.sign(tronweb.toHex(message))

            axios
                .post('api/cretaTransfer', {
                    address: address,
                    to_name: recipientName,
                    creta_amount: transferAmount,
                    signature: signature,
                    message: message,
                })
                .then((res) => {
                    alert('Transfer successfully.')
                    setRecipientName('')
                    setTransferAmount('')
                    setShowTransferForm(false)
                    refreshPage()
                })
                .catch((err) => {
                    if (err.response) {
                        alert(err.response.data.message)
                    }
                    setRecipientName('')
                    setTransferAmount('')
                })
        } catch (err) {
            if (err.response) {
                console.log(err.response)
                console.log(err.response.data.message)
                alert(err.response.data.message)
            }
        }
    }
    return (
        <>
            <div className="mining-header">
                <div className="flxd-title m-0">
                    My CRETA
                    <If condition={userDeposit > 0}>
                        <Then>
                            <span className="mining">mining</span>
                        </Then>
                    </If>
                </div>

                <If condition={userDeposit > 0}>
                    <Then>
                        <div className="sk-cube-grid">
                            <div className="sk-cube sk-cube1"></div>
                            <div className="sk-cube sk-cube2"></div>
                            <div className="sk-cube sk-cube3"></div>
                            <div className="sk-cube sk-cube4"></div>
                            <div className="sk-cube sk-cube5"></div>
                            <div className="sk-cube sk-cube6"></div>
                            <div className="sk-cube sk-cube7"></div>
                            <div className="sk-cube sk-cube8"></div>
                            <div className="sk-cube sk-cube9"></div>
                            <div className="sk-cube sk-cube7"></div>
                            <div className="sk-cube sk-cube8"></div>
                            <div className="sk-cube sk-cube9"></div>
                        </div>
                    </Then>
                </If>
            </div>

            <div className="mining-wrap">
                <div className="profit-wrap">
                    <div className="profit-header">
                        <p className="profit-name">Balance of CRETA</p>
                        <span className="profit-data profit-data-flxd"> {CountUpValue(creta)} </span>
                    </div>

                    <div>
                        <div className="my-creta-info-wallet">
                            <div className="info-wallet w-100">
                                <div className="address w-100">
                                    <If condition={!userMatic}>
                                        <Then>
                                            <div>
                                                There is no registered wallet address.
                                                <button className="btn btn-sm btn-dark ml-3" onClick={() => setShowMaticAddressForm(true)}>
                                                    Edit
                                                </button>
                                            </div>
                                        </Then>
                                        <Else>
                                            <div className="w-100">
                                                <div>
                                                    <WalletIcon width={16} height={16} style={{ marginRight: 5, paddingBottom: 0 }} />
                                                    {userMatic && userMatic.length > 40 ? userMatic.substr(0, 18) + '···' + userMatic.substring(26) : userMatic}
                                                </div>

                                                <div className="flex-space-between">
                                                    <div>
                                                        <CopyToClipboard text={userMatic} onCopy={() => alert('Copied! ')}>
                                                            <button className="btn btn-sm btn-dark btn-shadow">Copy</button>
                                                        </CopyToClipboard>
                                                        <button className="btn btn-sm btn-dark btn-shadow ml-1" onClick={() => setShowMaticAddressForm(true)}>
                                                            Edit
                                                        </button>
                                                    </div>
                                                    {/* <button className="btn btn-sm btn-dark btn-shadow ml-1" onClick={() => maticFaucetRequest()}>
                                                        Matic Charge
                                                    </button> */}
                                                </div>
                                            </div>
                                        </Else>
                                    </If>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />
                    <div className="flex-space-between">
                        <div>
                            <button className="btn btn-secondary btn-shadow btn-md " onClick={() => setShowWithdrawForm(true)}>
                                Withdraw
                            </button>
                            {/* <button
                className="btn btn-secondary btn-shadow btn-md ml-2"
                onClick={() => setShowDepositForm(true)}
              >
                Deposit
              </button> */}
                        </div>
                        {/* <button
              className="btn btn-primary btn-shadow btn-md "
              onClick={() => setCretaBuyModalOpen(true)}
            >
              Buy
            </button> */}

                        <div>
                            <button className="btn btn-secondary btn-shadow btn-md" onClick={() => setShowTransferForm(true)}>
                                Transfer
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal closeTimeoutMS={200} isOpen={showDepositForm} ariaHideApp={false}>
                <Deposit setShowDepositForm={setShowDepositForm} />
            </Modal>
            <Modal closeTimeoutMS={200} isOpen={showWithdrawForm} ariaHideApp={false}>
                <div className="modal-body">
                    <h2 className="mb-3">Withdraw CRETA</h2>
                    {notAllowedExchangeWallet()}
                    <div className="profit-header">
                        <p className="profit-name">Balance of CRETA</p>
                        <span className="profit-data profit-data-flxd"> {CountUpValue(creta)} </span>
                    </div>
                    <hr />
                    <div>
                        <input type="number" min="0" max={creta} value={withdrawCretaAmount} placeholder="Amount" onChange={onChangeWithdrawCreta} />
                    </div>
                    <p className="fee-text text-left">Fee 1%(max 200 CRETA), Minimum withdrawal CRETA token 10</p>

                    <hr />
                    <div className="flex-space-between mt-3">
                        <button className="btn btn-md btn-secondary" onClick={() => setShowWithdrawForm(false)}>
                            close
                        </button>
                        <button className="btn btn-md btn-primary" onClick={() => cretaWithdrawRequest()}>
                            Confirm
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal closeTimeoutMS={200} isOpen={showMaticAddressForm} ariaHideApp={false}>
                <div className="modal-body">
                    <h2 className="mb-3">Change CRETA Address(Matic)</h2>

                    <When condition={userMatic}>
                        <div className="text-left">Current address:</div>
                        <div>
                            <input className="modal-body color-gray" type="string" placeholder="Current address" value={userMatic} />
                        </div>
                        <hr />
                    </When>
                    <div className="text-left">New address:</div>
                    <div>
                        <input type="string" placeholder="New address" onChange={onChangeFixMaticAddress} />
                    </div>
                    <hr />
                    <div className="flex-space-between mt-3">
                        <button className="btn btn-md btn-secondary" onClick={() => setShowMaticAddressForm(false)}>
                            close
                        </button>
                        <button className="btn btn-md btn-primary" onClick={() => changeMaticAddress()}>
                            Confirm
                        </button>
                    </div>
                </div>
            </Modal>

            <Modal closeTimeoutMS={200} isOpen={showTransferForm} ariaHideApp={false}>
                <div className="modal-body">
                    <h2 className="mb-3">Transfer CRETA</h2>
                    <div className="profit-header">
                        <p className="profit-name">Balance of CRETA</p>
                        <span className="profit-data profit-data-flxd"> {CountUpValue(creta)} </span>
                    </div>
                    <hr />
                    <div>
                        <input type="string" placeholder="Recipient ID" value={recipientName} onChange={onChangeRecipientName} />
                    </div>
                    <div className="mt-3">
                        <input type="number" min="0" max={creta} value={transferAmount} placeholder="Amount" onChange={onChangeTransferAmount} />
                    </div>
                    <hr />
                    <div className="flex-space-between mt-3">
                        <button className="btn btn-md btn-secondary" onClick={() => setShowTransferForm(false)}>
                            close
                        </button>
                        <button className="btn btn-md btn-primary" onClick={() => transferCreta()}>
                            Confirm
                        </button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default CretaSection
